<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle18')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle18') }}</h1>
    <p>{{ $t('artText18-1') }}</p>
    <p>{{ $t('artText18-2') }}</p>
    <p>{{ $t('artText18-3') }}</p>
    <p>{{ $t('artText18-4') }}</p>
    <img
      :src="`${staticUrl}/images/blog/Small_Kitchen_Ideas_Smart_Solutions_for_Space_and_Style_with_DreamFlat.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText18-5') }}</p>
    <p>{{ $t('artText18-6') }}</p>
    <h2>{{ $t('artText18-7') }}</h2>
    <p>{{ $t('artText18-8') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle18')}`,
  ogTitle: `${t('artSeoTitle18')}`,
  description: `${t('artSeoDesc18')}`,
  ogDescription: `${t('artSeoDesc18')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
